var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dialog-form",
    {
      ref: "domainForm",
      attrs: { saveAction: _vm.saveAction, title: "Create License" },
      on: { closed: _vm.resetForm }
    },
    [
      _c(
        "div",
        { staticClass: "modal-content" },
        [
          _c(
            "md-layout",
            { staticClass: "form-section", attrs: { "md-flex": "100" } },
            [
              _c("metadata-form", {
                attrs: {
                  entity: _vm.license,
                  "form-submitted": _vm.formSubmitted,
                  validations: _vm.$v.license
                }
              })
            ],
            1
          ),
          _c(
            "md-layout",
            { staticClass: "form-section" },
            [
              _c("md-layout", { attrs: { "md-flex": "100" } }, [
                _c("div", { staticClass: "md-headline" }, [
                  _vm._v("Geographic Rules")
                ])
              ]),
              _c("md-layout", { attrs: { "md-flex": "100" } }, [
                _c(
                  "div",
                  { staticClass: "md-subheading", attrs: { id: "approach" } },
                  [_vm._v("Approach")]
                )
              ]),
              _c(
                "md-radio",
                {
                  staticClass: "md-primary",
                  attrs: { "md-value": "allow" },
                  model: {
                    value: _vm.license.geoList.mode,
                    callback: function($$v) {
                      _vm.$set(_vm.license.geoList, "mode", $$v)
                    },
                    expression: "license.geoList.mode"
                  }
                },
                [_vm._v("Allow")]
              ),
              _c(
                "md-radio",
                {
                  staticClass: "md-primary",
                  attrs: { "md-value": "deny" },
                  model: {
                    value: _vm.license.geoList.mode,
                    callback: function($$v) {
                      _vm.$set(_vm.license.geoList, "mode", $$v)
                    },
                    expression: "license.geoList.mode"
                  }
                },
                [_vm._v("Deny")]
              ),
              _c("country-selector", {
                model: {
                  value: _vm.license.geoList.countries,
                  callback: function($$v) {
                    _vm.$set(_vm.license.geoList, "countries", $$v)
                  },
                  expression: "license.geoList.countries"
                }
              })
            ],
            1
          ),
          _c(
            "md-layout",
            { staticClass: "form-section", attrs: { "md-flex": "100" } },
            [
              _c("domains-form", {
                staticClass: "domains-form",
                attrs: { entity: _vm.license }
              })
            ],
            1
          ),
          _c(
            "md-layout",
            { staticClass: "form-section", attrs: { "md-flex": "100" } },
            [
              _c("platforms-form", {
                staticClass: "platforms-form",
                attrs: { entity: _vm.license }
              })
            ],
            1
          ),
          _c(
            "md-layout",
            { staticClass: "form-section", attrs: { "md-flex": "100" } },
            [
              _c(
                "md-layout",
                { staticClass: "status", attrs: { "md-flex": "100" } },
                [
                  _c("div", { staticClass: "md-headline" }, [
                    _vm._v("Licensing Window")
                  ])
                ]
              ),
              _c("status-radio", {
                model: {
                  value: _vm.license.status,
                  callback: function($$v) {
                    _vm.$set(_vm.license, "status", $$v)
                  },
                  expression: "license.status"
                }
              }),
              _vm.license.status === "public"
                ? _c(
                    "md-layout",
                    { attrs: { "md-flex": "100", "md-gutter": "16" } },
                    [
                      _c(
                        "md-layout",
                        { attrs: { "md-flex": "50" } },
                        [
                          _c("date-input", {
                            attrs: {
                              validation: _vm.$v.license.startDate,
                              formSubmitted: _vm.formSubmitted,
                              label: "Available from"
                            },
                            model: {
                              value: _vm.license.startDate,
                              callback: function($$v) {
                                _vm.$set(_vm.license, "startDate", $$v)
                              },
                              expression: "license.startDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "md-layout",
                        { attrs: { "md-flex": "50" } },
                        [
                          _c("date-input", {
                            attrs: {
                              validation: _vm.$v.license.endDate,
                              formSubmitted: _vm.formSubmitted,
                              label: "Available until"
                            },
                            model: {
                              value: _vm.license.endDate,
                              callback: function($$v) {
                                _vm.$set(_vm.license, "endDate", $$v)
                              },
                              expression: "license.endDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "md-layout",
            { staticClass: "form-section", attrs: { "md-flex": "100" } },
            [
              _c("pricing-form", {
                staticClass: "pricing-form",
                attrs: { entity: _vm.license }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bf8e159a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf8e159a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/forms/LicenseFormDialog.vue
// module id = 942
// module chunks = 0